import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import '../dragtoimage.css'
import Grid from '@mui/material/Grid'

// Leave the ContainerComponents thing as comment here for now.
const DraggableCard = ({ item, index, styles, isDraggable }) => {
  const cardStyle = [];
  if (item.correct && styles.correctCard) {
    cardStyle.push(styles.correctCard)
  }
  if (item.correct === false && styles.wrongCard) {
    cardStyle.push(styles.wrongCard)
  }
  return (
    <Draggable draggableId={`drag:${item.id}`} index={index} key={`text:${item.id}`} isDragDisabled={isDraggable}>
      {(provided, snapshot) => {
        if (snapshot.isDragging) {
          provided.draggableProps.style.left = undefined;
          provided.draggableProps.style.top = undefined;
        }
        return (<>
          <Grid
            item
            key={item.id}
            role={undefined}
          >
            <div
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
              key={item.id}
            >
              <div className="talk-bubble tri-right border">
                <div className="talktext" style={{ fontSize: '1rem' }}>
                  {item.text}
                </div>
              </div>
              {provided.placeholder}
            </div>
          </Grid>
        </>)
      }}
    </Draggable >
  )
}

export default DraggableCard
